import React from "react";

const Tab = (props) => {
  return <p>{props.children}</p>;
};

export default Tab;
